export default __webpack_public_path__ + "static/media/FEI logo copy.53e99684.png";